<template><SimpleModuleDashboard :module-id="Modules.CURSOS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'crudCourses', reference: 'crudCourses', route: 'CoursesStaffCrudCourses', tone: 'primary' },
  { id: 'crudCategories', reference: 'crudCategories', route: 'CoursesStaffCrudCategories', tone: 'primary' },
] }) }
</script>
